import { useState } from 'react';
import { InputComponent } from 'components/UIComponents/EntityTable';
import {
  DropdownAddCategory,
  SetterNameValues,
} from '../../../components/DropdownAddCategory';
import { IOption } from 'components/UIComponents/MultiSelect';
import classNames from 'classnames';
import { editClaimsCategoryThunk } from 'reducer/thunks/claimsCategoriesThunks';
import { useAppDispatch } from 'hooks/reducerHooks';
import { AllClaimsCategories } from 'api/endpoints';
import {
  ApThreeWaySwitch,
  ApThreeWayValue,
} from 'components/ApThreeWayToggleSwitch';
import { ApLoaderDefault } from '@alixpartners/ui-components';

export const ClaimCategoriesInput: InputComponent<AllClaimsCategories> = ({
  columnKey,
  item,
  fromTable,
}) => {
  const { setValue, formSubmitted, options, disabled } = fromTable;
  const [toggleOn, setToggleOn] = useState(!!item?.enabled);
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  const handleToggleClick = async () => {
    setLoading(true);
    await dispatch(
      editClaimsCategoryThunk({
        enabled: !toggleOn,
        minorCategoryId: item?.minorCategoryId!,
        minorCategoryName: null,
      }),
    );
    setToggleOn((prev) => !prev);
    setLoading(false);
  };

  if (columnKey === 'majorCategoryId') {
    return (
      <DropdownAddCategory
        options={options!}
        addButtonText="new category"
        handleClick={(name: SetterNameValues, value: IOption) =>
          setValue(name, value)
        }
        formSubmitted={formSubmitted}
        valueSetters={{
          optionClickSetter: 'majorCategoryId',
          inputSetter: 'majorCategoryName',
        }}
      />
    );
  }
  if (columnKey === 'minorCategoryName') {
    return (
      <input
        className="minor-category-input"
        type="text"
        placeholder="Enter name"
        onChange={(e) => setValue('minorCategoryName', e.target.value)}
        disabled={disabled}
        defaultValue={item?.minorCategoryName ?? ''}
      />
    );
  }

  if (columnKey === 'majorCategoryName' && item?.majorCategoryName) {
    return <p>{item?.majorCategoryName}</p>;
  }

  if (columnKey === 'categoryType' && item?.categoryType) {
    return <p>{item?.categoryType}</p>;
  }
  if (columnKey === 'enabled') {
    if (loading) return <ApLoaderDefault loaderSize="sm" />;
    return (
      <span
        className={classNames('edit-table__cell-switch', {
          'utils-obstruct-panel': disabled || item?.usedInClaims,
        })}
      >
        <ApThreeWaySwitch
          value={!!item?.enabled ? ApThreeWayValue.Yes : ApThreeWayValue.No}
          onChange={handleToggleClick}
        />
      </span>
    );
  }

  return null;
};
